<template>
  <div class="">
    <el-table :data="dataList" border size="small" :height="400">
      <el-table-column type="index" :label="$t('order.parcel.serialNo')" width="60"></el-table-column>
      <el-table-column prop="porder_sn" width='240' :label="$t('order.parcel.logisticsNo')"></el-table-column>
      <el-table-column prop="pa_unit" :label="$t('order.parcel.size')" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ `${scope.row.pa_length} ${scope.row.pa_unit == 1 ? $t('order.parcel.inch') : $t('order.parcel.centimeter')} * ${scope.row.pa_width} ${scope.row.pa_unit == 1 ? $t('order.parcel.inch') : $t('order.parcel.centimeter')} * ${scope.row.pa_height} ${scope.row.pa_unit == 1 ? $t('order.parcel.inch') : $t('order.parcel.centimeter')}` }}
        </template>
      </el-table-column>
      <el-table-column prop="pa_lb" :label="$t('order.parcel.weight')" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ `${scope.row.pa_lb} ${scope.row.pa_unit == 1 ? $t('order.parcel.pound') : $t('order.parcel.kilogram')}` }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 合计：总重量 / 总体积重量(长×宽×高÷系数,逐个包裹相加) -->
    <div style="display:flex;flex-wrap:wrap;gap:12px 48px;align-items:center;margin-top:12px;padding:10px 16px;background:#ecf5ff;border:1px solid #d9ecff;border-radius:4px;font-size:14px;color:#303133;">
      <span>{{ $t('order.parcel.totalWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalWeight }} {{ weightUnitText }}</b></span>
      <span>{{ $t('order.parcel.totalVolumeWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalVolumeWeight }} {{ weightUnitText }}</b></span>
    </div>
  </div>
</template>

<script>
  import { packageInfo } from '@/api/order'
  export default {
    props: {
      order_id: {
        type: [Number,String],
        default: ''
      }
    },
    data() {
      return {
        dataList: [],
      };
    },
    computed: {
      // 是否英制：取首条包裹的 pa_unit(后端返回,1=英寸/磅,其余为厘米/千克)
      isImperial() {
        return this.dataList.length > 0 && this.dataList[0].pa_unit == 1
      },
      // 重量单位文案：英制显示"磅",公制显示"千克"
      weightUnitText() {
        return this.isImperial ? this.$t('order.parcel.pound') : this.$t('order.parcel.kilogram')
      },
      // 总重量 = Σ(各包裹重量 pa_lb)。详情接口返回的是按数量展开后的真实包裹明细,逐行相加即可,无需再乘数量
      totalWeight() {
        const sum = (this.dataList || []).reduce((acc, row) => acc + (parseFloat(row.pa_lb) || 0), 0)
        return sum.toFixed(2)
      },
      // 总体积重量 = Σ(长×宽×高 ÷ 系数)。英寸÷139得体积磅,厘米÷5000得体积千克
      totalVolumeWeight() {
        const divisor = this.isImperial ? 139 : 5000
        const sum = (this.dataList || []).reduce((acc, row) => {
          const l = parseFloat(row.pa_length) || 0
          const w = parseFloat(row.pa_width) || 0
          const h = parseFloat(row.pa_height) || 0
          return acc + l * w * h / divisor
        }, 0)
        return sum.toFixed(2)
      },
    },
    mounted(){
      this.getPackageInfo()
    },
    methods: {
      // 获取列表
      getPackageInfo(){
        packageInfo({
          user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          order_id: this.order_id
        }).then(res => {
          if(res.code == 1){
            this.dataList = []
            this.dataList = res.data
          }
        })
      },
    },
  };
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>